import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="border-t border-border bg-background py-10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + copyright */}
        <div className="flex items-center gap-4">
          <AppLogo text="LuxuryNailArt" size={28} className="text-primary" />
          <span className="text-muted text-sm">
            © {currentYear} LuxuryNailArt. All rights reserved.
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-6 text-sm font-medium text-muted">
          <a href="#gallery" className="hover:text-primary transition-colors duration-200">
            Gallery
          </a>
          <a href="#services" className="hover:text-primary transition-colors duration-200">
            Services
          </a>
          <a href="#booking" className="hover:text-primary transition-colors duration-200">
            Book
          </a>
          <span className="text-border">·</span>
          <a href="#" className="hover:text-primary transition-colors duration-200">
            Privacy
          </a>
          <a href="#" className="hover:text-primary transition-colors duration-200">
            Terms
          </a>
        </div>

        {/* Social icons */}
        <div className="flex items-center gap-4">
          <a
            href="#"
            aria-label="Instagram"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-border text-muted hover:text-primary hover:border-accent transition-all duration-200"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37m1.5-4.87h.01" />
            </svg>
          </a>
          <a
            href="#"
            aria-label="TikTok"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-border text-muted hover:text-primary hover:border-accent transition-all duration-200"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
            </svg>
          </a>
          <a
            href="#"
            aria-label="Pinterest"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-border text-muted hover:text-primary hover:border-accent transition-all duration-200"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 2C6.477 2 2 6.477 2 12c0 4.236 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.181-.78 1.172-4.97 1.172-4.97s-.299-.598-.299-1.482c0-1.388.806-2.428 1.808-2.428.852 0 1.265.64 1.265 1.408 0 .858-.546 2.14-.828 3.33-.236.995.499 1.806 1.476 1.806 1.772 0 3.137-1.867 3.137-4.563 0-2.387-1.715-4.055-4.163-4.055-2.836 0-4.5 2.126-4.5 4.322 0 .856.33 1.772.741 2.272a.3.3 0 0 1 .069.286c-.076.312-.244.995-.277 1.134-.044.183-.146.222-.336.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.966-.527-2.292-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446C17.523 22 22 17.523 22 12S17.523 2 12 2Z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
